<template>
  <!--Navbar-->
  <mdb-container fluid class="navbar-fluid-container px-0 sticky-top bg-white">
    <mdb-container>
      <mdb-navbar color="navbar-expand-md px-0 navbar-light">
        <!-- Navbar brand -->
        <mdb-navbar-brand>
          <router-link to="/">
            <img src="../assets/Exsellance_Logo.png" class="ex-logo" />
          </router-link>
        </mdb-navbar-brand>
        <mdb-navbar-toggler>
          <mdb-navbar-nav>


            <!--<mdb-dropdown tag="li" class="nav-item">
            <mdb-dropdown-toggle tag="a" navLink slot="toggle" waves-fixed>Browse</mdb-dropdown-toggle>
            <mdb-dropdown-menu>
              <mdb-dropdown-item>Videos</mdb-dropdown-item>
              <mdb-dropdown-item><router-link to="/podcasts">Initerviews</router-link>
              </mdb-dropdown-item>
              <mdb-dropdown-item>Masterclasses</mdb-dropdown-item>
              <mdb-dropdown-item>
                <router-link to="/community">Community</router-link>
              </mdb-dropdown-item>
              <mdb-dropdown-item>Articles</mdb-dropdown-item>
            </mdb-dropdown-menu>
            </mdb-dropdown>-->
          </mdb-navbar-nav>
          <!-- Search form -->
          <mdb-navbar-nav right class="nav-flex-icons">
            <mdb-nav-item href="#" class="my-1">
              <router-link to="/Team" v-if="iAmTheBoss==true" :key="iAmTheBoss">
                <mdb-icon icon="users" />
              </router-link>
            </mdb-nav-item>

            <mdb-dropdown tag="li" class="nav-item">
              <mdb-dropdown-toggle tag="a" navLink slot="toggle" waves-fixed class="pl-0">
                <router-link to="/Profile">
                  <img
                    v-if="getUserPhotourl != '' "
                    v-bind:src="getUserPhotourl"
                    v-bind:title="getUserName"
                    class="img-fluid rounded-circle z-depth-0"
                    alt="avatar image"
                    width="30px"
                    height="30px"
                  />

                  <!-- if no phpto url - two letters -->
                  <span
                    style="width: 28px;height:28px;"
                    v-if=" getUserPhotourl == '' "
                    class="avatar"
                  >{{twoLettersInsteadOfAvatar}}</span>
                </router-link>
              </mdb-dropdown-toggle>
              <mdb-dropdown-menu>
                <mdb-dropdown-item>
                  <router-link to="/Profile">Profile</router-link>
                </mdb-dropdown-item>
                <mdb-dropdown-item v-if="iAmTheBoss">
                  <router-link to="/Team">Your team</router-link>
                </mdb-dropdown-item>
                <mdb-dropdown-item>
                  <router-link to="/Logout">Logout</router-link>
                </mdb-dropdown-item>
              </mdb-dropdown-menu>
            </mdb-dropdown>
          </mdb-navbar-nav>
        </mdb-navbar-toggler>
      </mdb-navbar>
    </mdb-container>
  </mdb-container>
</template>

<script>
import { store } from "../store";
import {
  mdbNavbar,
  mdbContainer,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbDropdown,
  mdbDropdownMenu,
  mdbDropdownToggle,
  mdbInput,
  mdbDropdownItem,
  mdbFormInline,
  mdbIcon
} from "mdbvue";

export default {
  name: "Navbar",
  data() {
    return {
      userFromStore: null,
      twoLettersInsteadOfAvatar: "",
      iAmTheBoss: false
    };
  },
  computed: {
    getUserName: function() {
      return store.getters.getUser ? store.getters.getUser.email : "null";
    },
    getUserPhotourl: function() {
      return store.getters.getAvatarurl &&
        store.getters.getAvatarurl !== "" &&
        store.getters.getAvatarurl !== undefined
        ? store.getters.getAvatarurl
        : "";
    }
  },
  methods: {
    // mthGetAvatarUrlFromStore() {
    //   let toret = "";

    //   if (
    //     store.getters.getAvatarurl !== null &&
    //     store.getters.getAvatarurl !== ""
    //   )
    //     toret = store.getters.getAvatarurl;

    //   return toret;
    // },
    mthGetTwoLettersInsteadOfAvatarFromStore() {
      let toret = "";

      if (
        store.getters.getUser !== null &&
        store.getters.getUser !== undefined &&
        store.getters.getUser.email !== null &&
        store.getters.getUser.email !== undefined
      )
        toret = store.getters.getUser.email.substring(0, 2);

      return toret;
    }
  },
  created() {
    let iatb = this.$store.getters.getIamtheboss;
    //console.log(iatb);

    if (
      iatb === null ||
      iatb === undefined ||
      iatb === false ||
      iatb == false
    ) {
      this.iAmTheBoss = false;
    } else {
      this.iAmTheBoss = true;
    }

    this.iAmTheBoss = iatb;
    if (this.iAmTheBoss == null) this.iAmTheBoss = false;

    this.userFromStore = this.$store.getters.getUser;

    // console.log(
    //   "created says: this.iAmTheBoss=" + this.iAmTheBoss + ", iatb=" + iatb
    // );

    this.twoLettersInsteadOfAvatar = this.mthGetTwoLettersInsteadOfAvatarFromStore();
    //this.avatarurlFromStore = this.mthGetAvatarUrlFromStore();
  },
  components: {
    mdbNavbar,
    mdbContainer,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbDropdown,
    mdbDropdownMenu,
    mdbDropdownToggle,
    mdbDropdownItem,
    mdbFormInline,
    mdbInput,
    mdbIcon
  }
};
</script>
